import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { ActionItem, Box, Button, Text } from '@factorialco/deprecated-design-system'
import {
  DocumentTemplateDetailsDocument,
  DocumentTemplateDetailsQuery,
} from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import DocumentType from 'modules/core/components/DocumentType'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import SettingsButton from 'modules/documents/components/DocumentTemplates/Content/DocumentTemplatesList/SettingsButton'
import Tags from 'modules/documents/components/DocumentTemplates/Tags'
import type { DocumentTemplate } from 'modules/documents/hooks/useGetDocumentTemplates'

type TaskConfigurationSendDocumentTemplate =
  DocumentTemplateDetailsQuery['processes']['taskConfigurationSendDocumentTemplatesConnection']['nodes'][number]

interface Props {
  documentTemplate: DocumentTemplate
  taskConfigurations?: TaskConfigurationSendDocumentTemplate[]
}

const Item = ({ documentTemplate, taskConfigurations }: Props) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const goTo = () => {
    navigate(
      navigation.files.documentTemplates.documentTemplateId.fullPath({
        documentTemplateId: documentTemplate.id!,
      })
    )
  }

  const renderAction = () => {
    return (
      <Box flexDirection="row">
        <Box alignItems="center" flexDirection="row" gap="s8">
          <Box paddingRight="s16">
            <Tags documentTemplate={documentTemplate} taskConfigurations={taskConfigurations} />
          </Box>

          <SettingsButton
            documentTemplate={documentTemplate}
            taskConfigurations={taskConfigurations}
          />
          <Button
            aria-label={i18n.t('documents.document_templates.list.show_template')}
            type="secondary"
            onClick={goTo}
            iconName="arrow-right"
          />
        </Box>
      </Box>
    )
  }

  return (
    <ActionItem whiteDisabled>
      <Box width="full">
        <Box
          flexDirection="row"
          alignItems="center"
          justifyContent="spaceBetween"
          overflowX="hidden"
          gap="s8"
        >
          {documentTemplate.mimetype && <DocumentType mimetype={documentTemplate.mimetype} />}

          <Box overflowX="hidden" width="full">
            <Text color="grey1000" weight="medium" size="300" ellipsis>
              {documentTemplate.name}
            </Text>
          </Box>
          {renderAction()}
        </Box>
      </Box>
    </ActionItem>
  )
}

export default observer(Item)
